import { render, staticRenderFns } from "./rwpengangkatan.vue?vue&type=template&id=efb77cf2"
import script from "./rwpengangkatan.vue?vue&type=script&lang=js"
export * from "./rwpengangkatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports